import { ISMSCommunication } from 'shared';

import { InboxTable } from '../common/InboxTable';

import { SmsInboxRow } from './SmsInboxRow';

interface SmsInboxTableProps {
  rows: ISMSCommunication[];
  onRowClick: (sms: ISMSCommunication) => void;
}

export function SmsInboxTable({ rows, onRowClick }: SmsInboxTableProps) {
  return (
    <InboxTable
      columns={ [
        { key: `received`, label: `Received` },
        { key: `contact`, label: `Contact` },
        { key: `from`, label: `From` },
        { key: `message`, label: `Message` },
      ] }
      emptyMessage={ `No inbound SMS yet.` }
      hasRows={ rows.length > 0 }
    >
      { rows.map(sms => (
        <SmsInboxRow
          key={ sms.id }
          sms={ sms }
          onRowClick={ onRowClick }
        />
      )) }
    </InboxTable>
  );
}
